"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyledSeparator = exports.StyledRoot = void 0;

var _index = require("../styles/index.js");

var _index2 = require("../icon/index.js");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StyledRoot = (0, _index.styled)('nav', function (_ref) {
  var $theme = _ref.$theme;
  return _objectSpread({
    color: $theme.colors.breadcrumbsText
  }, $theme.typography.font450);
});
exports.StyledRoot = StyledRoot;
StyledRoot.displayName = "StyledRoot";
var StyledSeparator = (0, _index.styled)('div', function (_ref2) {
  var $theme = _ref2.$theme;
  return {
    display: 'inline-block',
    color: $theme.colors.breadcrumbsSeparatorFill,
    marginLeft: $theme.sizing.scale300,
    marginRight: $theme.sizing.scale300
  };
});
exports.StyledSeparator = StyledSeparator;
StyledSeparator.displayName = "StyledSeparator";
var StyledIcon = (0, _index.styled)(_index2.ChevronRight, function () {
  return {
    verticalAlign: 'text-bottom'
  };
});
exports.StyledIcon = StyledIcon;
StyledIcon.displayName = "StyledIcon";